// Blog post metadata for the marketing blog. Kept in a standalone module so
// both the blog index and the landing "From the blog" section can import it
// without pulling in a page component (avoids any load-order issues).
export const blogPosts = [
  {
    id: "fly-social-tools-complete-guide",
    title: "The Complete Guide to Fly Social Tools: AI-Powered SEO & Lead Generation Solutions for Agencies",
    excerpt: "Explore the complete range of Fly Social Tools, a suite of AI-powered, white-label marketing and Local SEO tools that help agencies generate qualified leads with free audits, reports, and content generators.",
    readTime: "8 min read",
    publishDate: "Jul 6, 2026",
    category: "Agency Guide",
    slug: "/blogs/fly-social-tools-complete-guide",
  },
  {
    id: "local-rank-checker",
    title: "Local Rank Checker: See How Your Business Ranks on Google Maps",
    excerpt: "Track your Google Maps rankings across different locations, discover visibility opportunities, monitor competitors, and embed a white-label Local Rank Checker on your website to generate qualified leads.",
    readTime: "7 min read",
    publishDate: "Jun 15, 2026",
    category: "Profile Optimization",
    slug: "/blogs/local-rank-checker",
  },
  {
    id: "gbp-audit-improve-local-rankings",
    title: "How a Google Business Profile Audit Tool Helps Businesses Improve Local Rankings",
    excerpt: "A Google Business Profile Audit Tool analyses every local ranking factor, finds hidden issues, and gives clear, data-driven insights to improve your visibility on Google Search and Google Maps.",
    readTime: "9 min read",
    publishDate: "Jun 10, 2026",
    category: "Profile Optimization",
    slug: "/blogs/google-business-profile-audit-improve-local-rankings",
  },
  {
    id: "agencies-more-local-seo-clients-gbp-audits",
    title: "How Agencies Can Get More Local SEO Clients Using Free Google Business Profile Audits",
    excerpt: "A free Google Business Profile Audit helps agencies attract more local SEO clients by identifying ranking issues, improving Google Maps visibility, and creating high-converting audit reports that turn prospects into paying customers.",
    readTime: "8 min read",
    publishDate: "Jun 10, 2026",
    category: "Agency Guide",
    slug: "/blogs/agencies-more-local-seo-clients-gbp-audits",
  },
  {
    id: "agency-manpower-fly-agent",
    title: "How Agencies Are Saving 20+ Hours Per Week Managing GBP with AI Assistants",
    excerpt: "Discover how marketing agencies are cutting GBP management time by 80% using Fly Agent with Claude, ChatGPT, and Gemini. Real strategies for scaling client portfolios without adding headcount.",
    readTime: "12 min read",
    publishDate: "Feb 13, 2026",
    category: "AI Tools",
    slug: "/blogs/agency-manpower-fly-agent",
    featured: true,
  },
  {
    id: "agency-suspension-proof-gbp",
    title: "How Agencies Build Suspension-Proof GBP Strategies for Clients",
    excerpt: "Learn how agencies build suspension-proof GBP strategies for clients. Expert guide to safe Google Business Profile management, compliance with Google guidelines, and avoiding suspension.",
    readTime: "14 min read",
    publishDate: "Dec 10, 2025",
    category: "Agency Guide",
    slug: "/blogs/agency-suspension-proof-gbp",
  },
  {
    id: "gmb-profile-audits",
    title: "GMB Profile Audits: Catch Issues Before Google Does",
    excerpt: "Learn how to conduct a comprehensive GMB profile audit to protect your local SEO and avoid Google suspension. Expert guide to catching compliance issues before they hurt your local ranking.",
    readTime: "12 min read",
    publishDate: "Dec 8, 2025",
    category: "Profile Optimization",
    slug: "/blogs/gmb-profile-audits",
  },
  {
    id: "gmb-maintenance-plan",
    title: "Stop Losing Customers: Why Every Local Business Needs a GMB Maintenance Plan",
    excerpt: "Discover why every local business needs a GMB maintenance plan for local SEO success. Learn how to maintain your GMB profile, manage reviews, and fight spam to dominate local search.",
    readTime: "14 min read",
    publishDate: "Dec 3, 2025",
    category: "Profile Optimization",
    slug: "/blogs/gmb-maintenance-plan",
  },
  {
    id: "get-patients-gbp-roadmap",
    title: "How to Get More Patients from Google Business Profile",
    excerpt: "Learn how to get more patients from Google Business Profile with this proven roadmap for clinics and doctors. Master Google Business Profile optimization and Local SEO strategies.",
    readTime: "16 min read",
    publishDate: "Dec 1, 2025",
    category: "Healthcare",
    slug: "/blogs/get-patients-gbp-roadmap",
  },
  {
    id: "auto-review-replies-tool",
    title: "How Our Tool Automatically Replies to Your Google Reviews Within 10 Minutes",
    excerpt: "Discover how our Google review auto-reply tool responds to all Google Business Profile reviews within 10 minutes. Boost Local SEO and reputation management effortlessly.",
    readTime: "18 min read",
    publishDate: "Nov 30, 2025",
    category: "AI Tools",
    slug: "/blogs/auto-review-replies-tool",
  },
  {
    id: "local-seo-checklist-clinic",
    title: '7-Step Local SEO Checklist to Rank Your Clinic on "Near Me" Searches',
    excerpt: "Follow this 7-step Local SEO checklist to rank your clinic on Google near me searches. Optimize your Google Business Profile and dominate local search results.",
    readTime: "15 min read",
    publishDate: "Nov 29, 2025",
    category: "Healthcare",
    slug: "/blogs/local-seo-checklist-clinic",
  },
  {
    id: "clinic-growth-digital-strategies",
    title: "Five Proven Digital Strategies to Grow Your Clinic's Patient Flow",
    excerpt: "Discover the Clinic Growth Blueprint: 5 digital strategies to grow your clinic's patient flow using Google Business Profile optimization and Local SEO.",
    readTime: "12 min read",
    publishDate: "Nov 28, 2025",
    category: "Healthcare",
    slug: "/blogs/clinic-growth-digital-strategies",
  },
  {
    id: "gmb-reinstatement-delays-tips-workarounds",
    title: "Dealing with GMB Reinstatement Delays – Tips & Workarounds",
    excerpt: "Facing GMB reinstatement delays? Learn why Google review timelines extend, how to fix delays, and smart workarounds to maintain Local SEO visibility during the wait.",
    readTime: "8 min read",
    publishDate: "Nov 28, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-reinstatement-delays-tips-workarounds",
  },
  {
    id: "gmb-reinstatement-appeal-essentials",
    title: "5 Things to Include in Your GMB Reinstatement Appeal to Avoid Rejection",
    excerpt: "Learn the 5 essential things to include in your GMB reinstatement appeal to avoid rejection. Expert tips to recover your suspended Google Business Profile successfully.",
    readTime: "10 min read",
    publishDate: "Nov 26, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-reinstatement-appeal-essentials",
  },
  {
    id: "gmb-account-suspension-prevention",
    title: "The Ultimate Guide: How to Ensure Your GMB Account Won't Be Suspended",
    excerpt: "Don't let a sudden suspension ruin your local SEO strategy. Learn why Google Business Profiles get suspended and what you can do to keep your GBP account active, compliant, and ranked high.",
    readTime: "12 min read",
    publishDate: "Nov 24, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-account-suspension-prevention",
  },
  {
    id: "gmb-reinstatement-denied",
    title: "What to Do If Your GMB Reinstatement Request Gets Denied",
    excerpt: "Learn what to do when your Google Business Profile reinstatement request gets denied. Step-by-step guide to fix issues, strengthen your appeal, and avoid GMB suspension in the future.",
    readTime: "15 min read",
    publishDate: "Nov 11, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-reinstatement-denied",
  },
  {
    id: "sample-appeal-template",
    title: "Sample Appeal Template to Recover a Suspended Google Business Profile",
    excerpt: "Get a ready-to-use Google Business Profile appeal template to recover your suspended GMB account. Learn how to file an effective GMB suspension appeal and get reinstated.",
    readTime: "9 min read",
    publishDate: "Nov 7, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/sample-appeal-template",
  },
  {
    id: "gmb-reinstatement-request",
    title: "How to File a GMB Reinstatement Request the Right Way",
    excerpt: "Learn the step-by-step process to file a GMB reinstatement request correctly and recover your suspended Google Business Profile. Avoid common mistakes and maximize your chances of success.",
    readTime: "10 min read",
    publishDate: "Nov 5, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-reinstatement-request",
  },
  {
    id: "multiple-profiles-backfire",
    title: "How Multiple Profiles for the Same Business Can Backfire",
    excerpt: "Learn why creating multiple Google Business Profiles for the same business can lead to suspension and hurt your local SEO. Discover best practices to avoid duplicate listing issues.",
    readTime: "9 min read",
    publishDate: "Nov 3, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/multiple-profiles-backfire",
  },
  {
    id: "updating-business-info-gmb-suspension",
    title: "Why Updating Business Info on GMB Can Sometimes Lead to Suspension",
    excerpt: "Learn why legitimate updates to your Google Business Profile can trigger suspension and how to safely update business info on GMB while avoiding policy violations.",
    readTime: "8 min read",
    publishDate: "Oct 30, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/updating-business-info-gmb-suspension",
  },
  {
    id: "posting-fake-reviews-keyword-stuffing",
    title: "Posting Fake Reviews, Keyword Stuffing & Other Red Flags on the GMB",
    excerpt: "Learn about fake reviews, keyword stuffing, and other red flags that can lead to Google Business Profile suspension. Discover how to protect your GBP and maintain compliance with Google's guidelines.",
    readTime: "10 min read",
    publishDate: "Oct 28, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/posting-fake-reviews-keyword-stuffing",
  },
  {
    id: "gbp-flagged-mistakes",
    title: "10 Mistakes That Can Get Your Google Business Profile Flagged",
    excerpt: "Discover the most common mistakes that can trigger Google's automated systems and get your Business Profile flagged. Learn how to avoid these pitfalls and maintain a compliant, high-performing listing.",
    readTime: "8 min read",
    publishDate: "Oct 16, 2025",
    category: "Profile Optimization",
    slug: "https://medium.com/@manu.mani/10-mistakes-that-can-get-your-google-business-profile-flagged-9cf975b54c71",
  },
  {
    id: "gmb-suspension-recovery-time",
    title: "How Long Does GMB Suspension Recovery Take?",
    excerpt: "Discover the typical timelines for GMB suspension recovery, understand different suspension types, and learn the step-by-step process to submit a successful reinstatement request to Google.",
    readTime: "6 min read",
    publishDate: "Aug 18, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/gmb-suspension-recovery-time",
  },
  {
    id: "google-business-profile-suspension",
    title: "The Top 7 Reasons for Google Business Profile Suspension (And How to Avoid Them)",
    excerpt: "Learn the main causes of Google Business Profile suspension and practical ways to avoid GMB suspension. Get your Google Business Profile back with our complete guide.",
    readTime: "12 min read",
    publishDate: "Aug 9, 2025",
    category: "Suspension Recovery",
    slug: "/blogs/google-business-profile-suspension",
  },
  {
    id: "gbp-quality-issues-suspension",
    title: 'Google Business Profile Suspended for "Quality Issues", What Does That Mean?',
    excerpt: "Your GMB = your reputation, new leads, highest local visibility. But it is natural to freak out when you sign in and the message appears: \"Your Google Business Profile has been suspended due to Quality Issues.\"",
    readTime: "5 min read",
    publishDate: "Oct 8, 2025",
    category: "Suspension Recovery",
    slug: "https://medium.com/@TheFlySocial/google-business-profile-suspended-for-quality-issues-what-does-that-really-mean-24fdb089e513",
  },
];
